module.exports = __webpack_public_path__ + "static/img/casino-open.7119a77.jpg";